import React from 'react';
import { observer } from 'mobx-react-lite';
import { ProfilePlaceholder } from '@vromo/ui/components/ProfileImage';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { useStore } from '@vromo/mobx-react/mobx-react';
import { RootStore } from '../stores/RootStore';
import { Site } from '@vromo/models';
import Debug from '@vromo/ui/components/Debug';
import { qaLabelTestSites } from './../../../../common-qa-labels/sites';
import { buildDynamicLabel } from './../../../../common-qa-labels/utils';

const PolicyItem = observer(function PolicyItem({ id }: { id?: number | null }) {
    const { policyStore } = useStore<RootStore>('rootStore');

    if (!id)
        return (
            <span style={{ color: '#FFB02E' }}>
                <FontAwesome icon="exclamation-triangle" style={{ paddingRight: '5px' }} />
                None - Manual Dispatch
            </span>
        );

    const policyName = policyStore.withId(id)?.name;

    return <>{policyName}</>;
});

interface SiteRowProps {
    onClick: () => void;
    site: Site;
}

export const SiteRow = observer<SiteRowProps>(function SiteRow({ onClick, site }) {
    const { campaignStore, blueprintStore, groupStore } = useStore<RootStore>('rootStore');

    const group = site.group ? groupStore.withId(site.group)?.name : null;
    const campaign = site.campaign?.id ? campaignStore.withId(site.campaign.id)?.name : null;
    const blueprint = site.blueprint?.id ? blueprintStore.withId(site.blueprint.id)?.name : null;

    return (
        <>
            <tr onClick={onClick} style={{ cursor: 'pointer' }}
             data-testid={buildDynamicLabel(qaLabelTestSites.tableRow, site.id)}> 
                <td style={{ textAlign: 'center', width: 50 }}>
                    <ProfilePlaceholder initials={site.contact!.name![0]!} id={site.id!} />
                </td>
                <td>{site.contact?.name}</td>
                <td>{site.contact?.address}</td>
                <td>{group}</td>
                <td>
                    <PolicyItem id={site.policy?.id} />
                </td>
                <td>{campaign}</td>
                <Debug>
                    <td>{blueprint}</td>
                </Debug>
            </tr>
        </>
    );
});
